module.exports = __webpack_public_path__ + "img/slant.svg";


//////////////////
// WEBPACK FOOTER
// ./img/slant.svg
// module id = 234
// module chunks = 0